module.exports = __webpack_public_path__ + "a761645c13fcbe15a7260c52a3c444fc.png";